import { ModalProps, styled } from '@attentive-platform/stem-ui';
import { TakeoffStatusEnum } from './types';
import { Modal } from '../Modal';
import { WarningIconColored } from '../Assets/WarningIconColored';

const CONTENT_MAP = {
  [TakeoffStatusEnum.IN_PROGRESS_QC]: {
    heading: 'Send takeoff for QA review?',
    bodyText:
      'All checklist items are marked as completed. The request will move for QA review. Do you want to proceed?'
  },
  [TakeoffStatusEnum.IN_PROGRESS_QA]: {
    heading: 'Send takeoff for final review?',
    bodyText:
      'All checklist items are marked as reviewed. The request will move for final review. Do you want to proceed?'
  }
};

const StyledTypegraphyVariant39 = styled('div')(() => ({
  fontWeight: 500,
  fontSize: '1.25rem',
  lineHeight: '1.5rem',
  letterSpacing: '0.0015em',
  color: 'var(--color-neutral-90)'
}));

const StyledTypographyVariantBody17 = styled('div')(() => ({
  color: 'var(--color-neutral-70)',
  fontWeight: 400,
  fontSize: '1rem',
  lineHeight: '1.5rem'
}));

const ModalContentContainer = styled('div')(() => ({
  alignItems: 'center',
  textAlign: 'center',
  '.heading': {
    marginTop: '0.5rem'
  },
  '.body-text': {
    margin: 'auto',
    marginTop: '1.125rem',
    width: '25.75rem'
  }
}));

type ConfirmationModalProps = {
  show: boolean;
  onClose: () => void;
  onYes: () => void;
  yesBtnLoading: boolean;
  status: TakeoffStatusEnum.IN_PROGRESS_QC | TakeoffStatusEnum.IN_PROGRESS_QA;
};

export const StatusUpdateConfirmationModal = ({
  show,
  onClose,
  onYes,
  yesBtnLoading,
  status
}: ConfirmationModalProps) => {
  const ctas = {
    primary: {
      label: 'Yes, proceed',
      variant: 'contained',
      color: 'primary',
      size: 'medium',
      loading: yesBtnLoading,
      onClick: () => {
        onYes();
        onClose();
      }
    },
    secondary: {
      label: 'Cancel',
      variant: 'outlined',
      color: 'primary',
      size: 'medium',
      onClick: onClose
    }
  };

  return (
    <Modal
      width='27.75rem'
      show={show}
      onClose={onClose}
      showCloseIcon={false}
      content={
        <ModalContentContainer>
          <div>
            <WarningIconColored width='2.5rem' height='2.5rem' />
          </div>
          <div className='heading'>
            <StyledTypegraphyVariant39>{CONTENT_MAP[status].heading}</StyledTypegraphyVariant39>
          </div>
          <div className='body-text'>
            <StyledTypographyVariantBody17>{CONTENT_MAP[status].bodyText}</StyledTypographyVariantBody17>
          </div>
        </ModalContentContainer>
      }
      ctas={ctas as ModalProps['ctas']}
      buttonPosition='center'
      zIndex={1500}
      ctasStyle={{ marginTop: '1.5rem' }}
      PaperProps={{
        style: {
          padding: '0.5rem',
          borderRadius: '0.5rem'
        }
      }}
    />
  );
};
